import { useState, useEffect } from 'react'
import { trackScrollDepth } from '../analytics'

export const useScrollDepthTracking = () => {
  const [scrollDepthTracked, setScrollDepthTracked] = useState(new Set())

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolled = Math.floor((scrollTop / docHeight) * 100)

      const milestones = [25, 50, 75, 100]
      milestones.forEach(milestone => {
        if (scrolled >= milestone && !scrollDepthTracked.has(milestone)) {
          trackScrollDepth(milestone)
          setScrollDepthTracked(prev => new Set([...prev, milestone]))
        }
      })
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [scrollDepthTracked])

  return scrollDepthTracked
}
